import httpClient from "@/plugins/axios";

export const getFaqList = async () => {
    const response = await httpClient.get('/v1/faq/?admin_view=1&translations=true');
    return response;
}

export const getFaq = async (id) => {
    const response = await httpClient.get(`/v1/faq/${id}/?admin_view=1&translations=1`)
    return response;
}

export const sort = async (sortedIds) => {
    const response = await httpClient.put('/v1/faq/sort/?admin_view=1', sortedIds);
    return response;
}

export const saveFaq = async (faq) => {

    if (faq.id) {
        return await updateFaq(faq);
    }
    else {
        return await insertFaq(faq);
    }
};

const insertFaq = async (faq) => {
    const response = await httpClient.post('/v1/faq/?admin_view=1', faq)
    return response;
}

const updateFaq = async (faq) => {
    const response = await httpClient.put(`/v1/faq/${faq.id}/?admin_view=1`, faq);
    return response;
}

export const deleteFaq = async (id) => {
    const response = await httpClient.delete(`/v1/faq/${id}/?admin_view=1`)
    return response;
}

